// extracted by mini-css-extract-plugin
export default {"errorMessage":"Login_errorMessage__xP25-"};